import { GlobalState } from '@leverege/ui-redux'
import { matchPath } from 'react-router'
// import { UnifiedHistory } from '@leverege/molten/startup'
import { Relationship, ImagineRelationship, UnifiedHistory } from '@leverege/molten-core'

import EventsItemDelegate from '../dataViewers/events/EventsItemDelegate'

let lastRel = null
let relationships = []

/**
 * The Ref for the objects belonging to this data source should
 * look like ':systemId/path_to_parent', The 'id' from the object
 * will be used to get the final action object. This minimizes
 * string construction for each unique path.
*/
export default class ProductEventsDataSource {
  dataSource() {
    return 'product.event'
  }

  getData( objRef ) {
    const historyItem = UnifiedHistory.get( GlobalState.get(), objRef.id )

    return historyItem
  }

  getDelegate( objRef ) {
    // get rid of <id>.history
    const segments = objRef.ref?.split( '/' )
    const deviceId = segments
      ?.[segments.length - 1]
      ?.replace( '.event', '' )
    let refToUse
    if ( objRef.ref.endsWith( `/${deviceId}/${deviceId}.event` ) ) {
      refToUse = segments.slice( 0, -1 ).join( '/' )
    } else {
      refToUse = segments.join( '/' ).replace( '.event', '' )
    }
    // const refToUse = objRef.ref?.split( '/' ).slice( 0, -1 ).join( '/' )
    const rel = ProductEventsDataSource.getRelationshipFor( refToUse )
    if ( rel != null ) {
      // rel is { match, relationship }
      return new EventsItemDelegate( { 
        match : rel.match, 
        relationship : rel.relationship.createResolved( rel.match ) 
      } )
    }
    return null
  }

  static getRelationshipFor( ref ) {
    if ( lastRel !== Relationship.getAll() ) {
      lastRel = Relationship.getAll()
      
      // rebuild relationships on a change
      relationships = lastRel
        .filter( rel => rel instanceof ImagineRelationship )
        .map( ( rel ) => {
          // const r = Relationship.createItemRelationship( rel ) 
          const r = rel.createItem( )
          const lastSegment = r.objRefUrlPath.substring( r.objRefUrlPath.lastIndexOf( '/' ) + 1 )
          const match = {
            path : lastSegment.includes( ':' ) ?
              r.objRefUrlPath :
              r.objRefUrlPath.replace( lastSegment, `:${lastSegment}Id` ),
            exact : true,
            strict : true
          }
          return { match, relationship : r }
        } )
      ProductEventsDataSource.sort()
    }
    
    for ( let n = 0; n < relationships.length; n++ ) {
      const rel = relationships[n]
      const match = matchPath( ref, rel.match )
      if ( match ) {
        return { match, relationship : rel.relationship }
      }
    }
    return null
  }
  
  static sort() {
    relationships.sort( ( a, b ) => { 
      return a.relationship.objRefUrlPath.localeCompare( b.relationship.objRefUrlPath )
    } )
  }
}
